import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// `withCredentials` lets the browser include the httpOnly `tt_session` cookie
// the backend sets after register / login / reset-password.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    const path = window.location.pathname;
    // Public pages must never force-redirect on a 401 (e.g. the marketing
    // page's /auth/me probe returns 401 for guests — that's expected).
    const PUBLIC_PATHS = ["/", "/login", "/register", "/forgot-password", "/reset-password", "/privacy", "/terms", "/brand"];
    if (status === 401) {
      localStorage.removeItem("tt_user");
      if (!PUBLIC_PATHS.includes(path)) {
        window.location.href = "/login";
      }
    }
    if (status === 402 && !window.location.pathname.startsWith("/billing")) {
      window.location.href = "/billing";
    }
    return Promise.reject(err);
  }
);
